import './_footer.scss'

export const Footer = () => {
    return (
        <footer>
            <p>Copyright &copy; 2021 | by Luna Rico</p>
        </footer>
    )
}